module.exports = __webpack_public_path__ + "static/media/MediaPlayer.b8e555e7.svg";